import NotFound from '@components/NotFound/NotFound'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { Main } from './Main'

export const OptionalMain: React.FC = () => {
  const error = useSelector<AppState, string | null>((state) => state.ui.error)

  if (error) {
    return <NotFound />
  }

  return <Main />
}
